import { render, staticRenderFns } from "./EditPokemon.vue?vue&type=template&id=ff9cd15a&scoped=true&lang=pug&"
import script from "./EditPokemon.vue?vue&type=script&lang=js&"
export * from "./EditPokemon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9cd15a",
  null
  
)

export default component.exports